module.exports = __webpack_public_path__ + "static/media/Two_Hand_A.d5063876.png";